module.exports = __webpack_public_path__ + "img/launch.315997ff.png";